<div class="modal-header">
  <i class="fas fa-exclamation-triangle fa-2x errorIcon"></i>
  <h4 id="alert-modal-title" class="modal-title errorTittle">{{'common.error' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{error.errorMessage | translate}}</p>
  <ul class="list-group" *ngIf="error.causes !== undefined && error.causes !== null && error.causes.length !== 0">
    <li class="list-group-item" *ngFor="let cause of error.causes">{{cause | translate}}</li>
  </ul>
</div>
<div class="modal-footer">
  <button type="button" ngbAutoFocus class="btn btn-primary" (click)="accept()">{{'common.close' | translate}}</button>
</div>

<!-- <ng-template #errorDiv let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <i class="fas fa-exclamation-triangle fa-2x errorIcon"></i>
        <h4 id="alert-modal-title" class="modal-title errorTittle">{{'common.error' | translate}}</h4>
        <button type="button" class="close" (click)="hidenError()" title="{{'common.close' | translate}}" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div id="alert-modal-body" class="modal-body">
        <p>{{error.errorMessage | translate}}</p>
        <ul class="list-group" *ngIf="error.causes !== undefined && error.causes !== null && error.causes.length !== 0">
          <li class="list-group-item" *ngFor="let cause of error.causes">{{cause | translate}}</li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-user btn-block" (click)="hidenError()">{{'common.close' | translate}}</button>
      </div>
    </div>
</ng-template> -->
